<template>
  <ul class="filter">
    <router-link v-for="filter in filters" :key="filter.value"
                 :to="filter.value" custom v-slot="{ isActive }"
    >
      <li @click="() => onClick(filter.value)">
        <span :class="isActive ? 'active' : ''">{{ filter.name }}</span>
      </li>
    </router-link>
  </ul>
</template>
<script>

export default {
  name: 'AbstractRouteFilters',
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    onClick: {
      type: Function,
      default: () => {
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.filter {
  display: flex;
  flex-direction: row;
  list-style: none;
  justify-content: center;
  margin: 0;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
  }

  @media (max-width: $medium) {
    display: -webkit-box;
    min-height: 50px;
    padding-left: 5px;
    overflow-x: scroll;
    overflow-y: hidden;
    li {
      min-width: 30vw;
      margin-left: auto;
      margin-right: auto;
    }
    justify-content: space-around;
  }

  li {
    margin-right: 2rem;
  }

  span {

    @media (max-width: $small) {
      margin-right: 1rem;
      margin-left: 1rem;
    }
    color: $black-color;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: $primary-color;
    }

    &.active {
      font-weight: 600;
      color: $primary-color;
    }
  }
}
</style>
